import React from "react";
import "./SkeletonLoader.css";

interface SkeletonLoaderProps {
  type:
    | "table"
    | "vertical-chart"
    | "donut"
    | "hierarchy"
    | "leaderboard"
    | "challenge-card"
    | "horizontal-chart"
    | "teamstats"; // ✅ new combined variant
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ type }) => {
  return (
    <div className="skeleton-loader">
      {type === "table" && (
        <>
          <div className="skeleton-title"></div>
          <div className="skeleton-row"></div>
          <div className="skeleton-row"></div>
          <div className="skeleton-row"></div>
        </>
      )}

      {type === "vertical-chart" && (
        <div className="chart-bars-wrapper">
          {[...Array(8)].map((_, i) => (
            <div
              key={i}
              className="skeleton-chart-bar"
              style={{ height: `${80 + Math.random() * 100}px` }}
            />
          ))}
        </div>
      )}

      {type === "horizontal-chart" && (
        <div style={{ width: "100%" }}>
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              style={{
                height: "24px",
                width: `${30 + Math.random() * 50}%`,
                marginBottom: "16px",
                background:
                  "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                backgroundSize: "200% 100%",
                animation: "shimmer 1.5s infinite",
                borderRadius: "4px",
              }}
            />
          ))}
        </div>
      )}

      {type === "donut" && <div className="skeleton-donut"></div>}

      {type === "hierarchy" && (
        <div className="skeleton-hierarchy-tree">
          {[...Array(3)].map((_, levelIdx) => (
            <div className="skeleton-hierarchy-row" key={levelIdx}>
              {[...Array(levelIdx + 2)].map((_, nodeIdx) => (
                <div key={nodeIdx} className="skeleton-hierarchy-node"></div>
              ))}
            </div>
          ))}
        </div>
      )}

      {type === "leaderboard" && (
        <div className="leaderboard-skeleton">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="leaderboard-skeleton-card shimmer" />
          ))}
        </div>
      )}

      {type === "challenge-card" && (
        <div className="challenge-card-skeleton">
          <div className="challenge-card-image shimmer"></div>
          <div className="challenge-card-title shimmer"></div>
          <div className="challenge-card-subtitle shimmer"></div>
          <div className="challenge-card-footer shimmer"></div>
        </div>
      )}

      {/* ✅ NEW: Combined skeleton for Top Performers + Top Teams */}
      {type === "teamstats" && (
        <div className="teamstats-skeleton">
          {/* Top Performers (Leaderboard style) */}
          <div className="leaderboard-skeleton">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="leaderboard-skeleton-card shimmer" />
            ))}
          </div>

          {/* Top Teams (Bar chart style) */}
          <div className="chart-bars-wrapper">
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="skeleton-chart-bar"
                style={{ height: `${60 + i * 15}px` }}
              ></div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SkeletonLoader;
